<template>
  	<div class="animated fadeIn">
		<b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-align-justify"></i><strong> {{$trans['general']['nav_net_salary']}}</strong> <small v-if="year !== null"> - {{year}}</small>
			        </div>
			        <div>
						<b-row>
							<b-col md="12">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['year']" label-for="sel-year">
											<b-form-select id="sel-year" v-model="year">
												<option v-for="(item, idx) in years" :key="idx" :value="item">{{item}}</option>
											</b-form-select>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</div>
					<div v-if="year !== null">
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['region']" label-for="sel-region">
											<b-form-select id="sel-region" :class="(inputs_errors.region.has_error) ? 'is-invalid' : ''" v-model="inputs.region">
												<option v-for="(item, idx) in regions" :key="idx" :value="idx">{{item}}</option>
											</b-form-select>
											<small v-if="inputs_errors.region.has_error" class="text-danger">{{inputs_errors.region.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['sector']" label-for="sel-sector">
											<b-form-select id="sel-sector" :class="(inputs_errors.sector.has_error) ? 'is-invalid' : ''" v-model="inputs.sector">
												<option v-for="(item, idx) in sectors" :key="idx" :value="idx">{{item}}</option>
											</b-form-select>
											<small v-if="inputs_errors.sector.has_error" class="text-danger">{{inputs_errors.sector.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['situation']" label-for="sel-situation">
											<b-form-select id="sel-situation" :class="(inputs_errors.situation.has_error) ? 'is-invalid' : ''" v-model="inputs.situation">
												<option v-for="(item, idx) in situations" :key="idx" :value="idx">{{item.val}}</option>
											</b-form-select>
											<small v-if="inputs_errors.situation.has_error" class="text-danger">{{inputs_errors.situation.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['dependents']" label-for="sel-dependents">
											<b-form-select id="sel-dependents" :class="(inputs_errors.dependents.has_error) ? 'is-invalid' : ''" v-model="inputs.dependents">
												<option v-for="(item, idx) in dependents" :key="idx" :value="idx">{{item}}</option>
											</b-form-select>
											<small v-if="inputs_errors.dependents.has_error" class="text-danger">{{inputs_errors.dependents.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['base_salary']" label-for="base_salary">
											<b-form-input id="base_salary" type="number" step="0.01" :class="(inputs_errors.base_salary.has_error) ? 'is-invalid' : ''" v-model="inputs.base_salary"></b-form-input>
											<small v-if="inputs_errors.base_salary.has_error" class="text-danger">{{inputs_errors.base_salary.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['subsidies']" label-for="sel-subsidio">
											<b-form-select id="sel-subsidio" :class="(inputs_errors.subsidio.has_error) ? 'is-invalid' : ''" v-model="inputs.subsidio">
												<option v-for="(item, idx) in subsidios" :key="idx" :value="idx">{{item}}</option>
											</b-form-select>
											<small v-if="inputs_errors.subsidio.has_error" class="text-danger">{{inputs_errors.subsidio.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['others_renu_suj']" label-for="others_renu_suj">
											<b-form-input id="others_renu_suj" type="number" step="0.01" v-model="inputs.others_renu_suj"></b-form-input>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['others_renu_not_suj']" label-for="others_renu_not_suj">
											<b-form-input id="others_renu_not_suj" type="number" step="0.01" v-model="inputs.others_renu_not_suj"></b-form-input>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="4">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['sub_alimentation']" label-for="sel-sub_alimentation">
											<b-form-select id="sel-sub_alimentation" :class="(inputs_errors.sub_alimentation_isencao.has_error) ? 'is-invalid' : ''" v-model="inputs.sub_alimentation_isencao">
												<option v-for="(key, val) in sub_alimentations_isencoes" :key="key" :value="key">{{val}}</option>
											</b-form-select>
											<small v-if="inputs_errors.sub_alimentation_isencao.has_error" class="text-danger">{{inputs_errors.sub_alimentation_isencao.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="4">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['val_sub_alimentation']" label-for="sub_alimentation">
											<b-form-input id="sub_alimentation" type="number" step="0.01" :class="(inputs_errors.val_sub_alimentation.has_error) ? 'is-invalid' : ''" v-model="inputs.val_sub_alimentation"></b-form-input>
											<small v-if="inputs_errors.val_sub_alimentation.has_error" class="text-danger">{{inputs_errors.val_sub_alimentation.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="4">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="$trans[$route.meta.trans_key]['paid_days']" label-for="paid_days">
											<b-form-input id="paid_days" type="number" step="0.01" :class="(inputs_errors.paid_days.has_error) ? 'is-invalid' : ''" v-model="inputs.paid_days"></b-form-input>
											<small v-if="inputs_errors.paid_days.has_error" class="text-danger">{{inputs_errors.paid_days.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col lg="6">
								<b-row>
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group :label="'% ' +$trans[$route.meta.trans_key]['seg_social']" label-for="seg_social">
											<b-form-input id="seg_social" type="number" step="0.01" :class="(inputs_errors.seg_social.has_error) ? 'is-invalid' : ''" v-model="inputs.seg_social"></b-form-input>
											<small v-if="inputs_errors.seg_social.has_error" class="text-danger">{{inputs_errors.base_salary.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
							<b-col lg="6">
								<b-row v-show="inputs.sector === 1">
									<b-col md="12">
										<!-- <label for="choose-item">Escolher Concelho</label> -->
										<b-form-group label="% de ADSE" label-for="adse">
											<b-form-input id="adse" type="number" step="0.01" :class="(inputs_errors.adse.has_error) ? 'is-invalid' : ''" v-model="inputs.adse"></b-form-input>
											<small v-if="inputs_errors.adse.has_error" class="text-danger">{{inputs_errors.adse.error}}</small>
										</b-form-group>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row>
							<b-col sm="12" class="padding-t-15 text-center">
								<button v-on:click="get_irs_data" class="btn btn-lg btn-info">Calcular</button>
							</b-col>
						</b-row>
						<b-row>
							<b-col sm="12">
								<datatable class="censos_table" v-if="table_data !== null" v-bind:data_table="table_data"></datatable>
							</b-col>
						</b-row>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
export default {
	name: 'Net_Salary',
	data() {
		return {
			year: '',
			irs_data: [],
			tax_irs: null,
			years: [],
			regions: [],
			years_regions: [],
			isencoes: {},
			sub_alimentations_isencoes: {},
			year_data: null,
			sectors: [this.$trans[this.$route.meta.trans_key]['private'], this.$trans[this.$route.meta.trans_key]['public']],
			situations: [{key:'nao_casado', val:'Não casado'}, {key:'casado_unico_titular', val:'Casado único titular'}, {key:'casado_dois_titulares', val:'Casado dois titulares'}, {key:'nao_casado_def', val:'Não casado Deficiente'}, {key:'casado_unico_titular_def', val:'Casado único titular deficiente'}, {key:'casado_dois_titulares_def', val:'Casado dois titulares deficiente'}],
			dependents: [0,1,2,3,4,this.$trans[this.$route.meta.trans_key]['5_or_more']],
			subsidios: ['Por inteiro', '50% de 1 subsídio em duodécimos', '1 subsídio em duodécimos', '2 subsídios em duodécimos'],
			inputs: {
				sector: null,
				adse: 0,
				region: null,
				sub_alimentation_isencao: null,
				situation: null,
				dependents: null,
				subsidio: null,
				val_sub_alimentation: null,
				paid_days: null,
				others_renu_suj: 0,
				others_renu_not_suj: 0,
				seg_social: 11,
				base_salary: null
			},
			inputs_errors: {
				region: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				situation: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				sector: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				dependents: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				subsidio: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				sub_alimentation_isencao: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['choose_one']
				},
				/*others_renu_suj: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},
				others_renu_not_suj: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},*/
				val_sub_alimentation: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},
				adse: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},
				paid_days: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},
				base_salary: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				},
				seg_social: {
					has_error: false,
					error: this.$trans[this.$route.meta.trans_key]['invalid_val']
				}
			},
			table_data: null
		}
	},
	watch: {
		year: function(new_val, old_val) {
			this.sub_alimentations_isencoes = this.isencoes[this.year];
			this.regions = this.years_regions[this.year];
			this.inputs.sub_alimentation_isencao = null;
			this.inputs.region = null;
		},
		'inputs.sector': function(new_val, old_val) {
			if(new_val == 1)
				this.inputs.adse = 3.5;
			else
				this.inputs.adse = 0;
			this.inputs_errors.adse.has_error = false;
		},
		'inputs.others_renu_suj': function(new_val, old_val) {
			this.inputs.others_renu_suj = (isNaN(new_val)) ? 0 : parseFloat(new_val);
		},
		'inputs.others_renu_not_suj': function(new_val, old_val) {
			this.inputs.others_renu_not_suj = (isNaN(new_val)) ? 0 : parseFloat(new_val);
		}
	},
	methods: {
		/*validate_inputs: function() {
			for(let i in this.inputs_errors)
		},*/
		validate: function() {
			let ok = true;
			for(let ie in this.inputs) {
				if(ie in this.inputs_errors) {
					if(isNaN(this.inputs[ie]) || this.inputs[ie] === null || this.inputs[ie] === '') {
						this.inputs_errors[ie].has_error = true;
						this.table_data = null;
						if(ok)
							ok = false;
					}
					else
						this.inputs_errors[ie].has_error = false;
				}
			}
			return ok;
		},
		get_irs_data: function() {

			if(!this.validate())
				return;

			const that = this;

			that.post_req('net-salary', {year: that.year, region: that.regions[that.inputs.region], dependents: that.inputs.dependents, situation: that.situations[that.inputs.situation].key},
				function() { // before
					// that.table_data = null;
	            },
				function(response) { // success
					that.irs_data = response.body;
					if(that.irs_data.length > 0)
						that.calc();
				},
				function(response) { // fail
					console.log('ajax main.js error: '+ response.status);
				},
				function(response) {
					
				});
		},
		format_money: function(val) {
			return new Intl.NumberFormat(this.$route.params.lang+ '-' +this.$route.params.lang.toUpperCase(), {style: 'currency', currency: 'EUR'}).format(val);
			//return new Intl.NumberFormat('pt-PT', {style: 'currency', currency: 'EUR'}).format(val);
		},
		calc_sal_brute_duo: function() {
			if(this.inputs.subsidio == 1)
				return (this.inputs.base_salary*0.5) / 12;
			if(this.inputs.subsidio == 2)
				return this.inputs.base_salary / 12;
			return (this.inputs.base_salary * 2) / 12;
		},
		find_irs_tax(val_sujeito_a_irs_seg_social) {

			if(this.irs_data.length === 0)
				return 0;

			let max_salary = this.irs_data[this.irs_data.length - 1];
			let min_salary = this.irs_data[0];

			if(val_sujeito_a_irs_seg_social < min_salary.salary)
				return min_salary.tax_irs;
			else if(val_sujeito_a_irs_seg_social > max_salary.salary)
				return max_salary.tax_irs;
			else {
				for(let i=0; i < this.irs_data.length-2; i++) {
					if(val_sujeito_a_irs_seg_social > this.irs_data[i].salary && val_sujeito_a_irs_seg_social <= this.irs_data[i+1].salary) {
						return this.irs_data[i+1].tax_irs;
					}
				}
			}
		},
		calc: function() {

			if(this.inputs.dependents > 5)
				this.inputs.dependents = 5
			else if(this.inputs.dependents < 0)
				this.inputs.dependents = 0

			var sub_food_total = this.inputs.val_sub_alimentation * this.inputs.paid_days;
			var sub_food_sujeito_a_irs_seg_e_social = sub_food_total - (this.inputs.sub_alimentation_isencao * this.inputs.paid_days);
			
			var base_salary_tmp = parseFloat(this.inputs.base_salary);

			if(sub_food_sujeito_a_irs_seg_e_social < 0)
				sub_food_sujeito_a_irs_seg_e_social = 0;

			var val_sujeito_a_irs_seg_social = base_salary_tmp + sub_food_sujeito_a_irs_seg_e_social + this.inputs.others_renu_suj;

			this.tax_irs = this.find_irs_tax(val_sujeito_a_irs_seg_social);

			var ADSE_total = (this.inputs.adse/100) * val_sujeito_a_irs_seg_social;

			var retencao_irs_total = Math.floor(val_sujeito_a_irs_seg_social * (this.tax_irs/100));
			var seg_social_total = val_sujeito_a_irs_seg_social * (this.inputs.seg_social/100);
			var sal_brute = base_salary_tmp + sub_food_total + this.inputs.others_renu_suj;
			var imposto_total = retencao_irs_total+seg_social_total+ADSE_total;

			var net_salary = sal_brute - retencao_irs_total - seg_social_total - ADSE_total + this.inputs.others_renu_not_suj;

			var table_data_tmp = {
				sortable: false,
				cols: ['', 'Regular'],
				rows: [
					[this.$trans[this.$route.meta.trans_key]['base_salary'], this.format_money(this.inputs.base_salary)],
					[this.$trans[this.$route.meta.trans_key]['val_sub_alimentation'], this.format_money(this.inputs.val_sub_alimentation)],
					[this.$trans[this.$route.meta.trans_key]['val_suj_seg_irs'], this.format_money(val_sujeito_a_irs_seg_social)],
					[this.$trans[this.$route.meta.trans_key]['sub_ali_suj_seg_irs'], this.format_money(sub_food_sujeito_a_irs_seg_e_social)],
					[this.$trans[this.$route.meta.trans_key]['total_brute'], this.format_money(sal_brute)],
					[this.$trans[this.$route.meta.trans_key]['tax_irs'], '<span class="text-primary">' +this.tax_irs+ ' %</span>'],
					[this.$trans[this.$route.meta.trans_key]['tax_social_seg'], '<span class="text-primary">' +this.inputs.seg_social+ ' %</span>'],
					[this.$trans[this.$route.meta.trans_key]['tax_adse'], '<span class="text-primary">' +this.inputs.adse+ ' %</span>'],
					[this.$trans[this.$route.meta.trans_key]['retencao_irs_total'], '<span class="text-danger">-' +this.format_money(retencao_irs_total)+ '</span>'],
					[this.$trans[this.$route.meta.trans_key]['seg_social_total'], '<span class="text-danger">-' +this.format_money(seg_social_total)+ '</span>'],
					['Total ADSE', '<span class="text-danger">-' +this.format_money(ADSE_total)+ '</span>'],
					[this.$trans[this.$route.meta.trans_key]['total_taxes'], '<span class="text-danger">-' +this.format_money(imposto_total)+ '</span>'],
					[this.$trans[this.$route.meta.trans_key]['sub_ali_total'], '<span class="text-success" style="font-size:16px;">' +this.format_money(sub_food_total)+ '</span>'],
					[this.$trans[this.$route.meta.trans_key]['net_salary'], '<span class="text-success" style="font-size:16px;">' +this.format_money(net_salary-sub_food_total)+ '</span>'],
					['<b style="font-size:16px;">' +this.$trans[this.$route.meta.trans_key]['total_net_salary']+ '</b>', '<b class="text-success" style="font-size:16px;">' +this.format_money(net_salary)+ '</b>']
				]
			}

			if(this.inputs.subsidio != 0) {
				var sal_brute_duo = this.calc_sal_brute_duo();
				var val_sujeito_a_irs_seg_social_duo = sal_brute_duo;
				var retencao_irs_duo = Math.floor(val_sujeito_a_irs_seg_social_duo * (this.tax_irs/100));
				var seg_social_duo = val_sujeito_a_irs_seg_social_duo * (this.inputs.seg_social/100);
				var ADSE_duo = val_sujeito_a_irs_seg_social_duo * (this.inputs.adse/100);
				var sal_net_duo = sal_brute_duo - retencao_irs_duo - seg_social_duo - ADSE_duo;

				table_data_tmp.cols.push('Duodécimos');
				table_data_tmp.cols.push('Total');
		
				table_data_tmp.rows[0].push(this.format_money(this.inputs.base_salary));
				table_data_tmp.rows[1].push(this.format_money(this.inputs.val_sub_alimentation));
				table_data_tmp.rows[2].push(this.format_money(sub_food_total));
				table_data_tmp.rows[3].push(this.format_money(val_sujeito_a_irs_seg_social_duo));
				table_data_tmp.rows[4].push(this.format_money(sub_food_sujeito_a_irs_seg_e_social));
				table_data_tmp.rows[5].push(this.format_money(sal_brute_duo));
				table_data_tmp.rows[6].push('<span class="text-primary">' +this.tax_irs+ ' %</span>');
				table_data_tmp.rows[7].push('<span class="text-primary">' +this.inputs.seg_social+ ' %</span>');
				table_data_tmp.rows[8].push('<span class="text-primary">' +this.inputs.adse+ ' %</span>');
				table_data_tmp.rows[9].push('<span class="text-danger">-' +this.format_money(retencao_irs_duo)+ '</span>');
				table_data_tmp.rows[10].push('<span class="text-danger">-' +this.format_money(seg_social_duo)+ '</span>');
				table_data_tmp.rows[11].push('<span class="text-danger">-' +this.format_money(ADSE_duo)+ '</span>');
				table_data_tmp.rows[12].push('<span class="text-danger">-' +this.format_money(imposto_total)+ '</span>');
				table_data_tmp.rows[13].push('<b class="text-success" style="font-size:16px;">' +this.format_money(sal_net_duo)+ '</b>');

				sal_brute = sal_brute_duo + sal_brute;
				val_sujeito_a_irs_seg_social = val_sujeito_a_irs_seg_social_duo + val_sujeito_a_irs_seg_social;
				retencao_irs_total = retencao_irs_duo + retencao_irs_total;
				seg_social_total = seg_social_duo + seg_social_total;
				ADSE_total = ADSE_duo + ADSE_total;
				net_salary = sal_net_duo + net_salary + this.inputs.others_renu_not_suj;

				table_data_tmp.rows[0].push(this.format_money(this.inputs.base_salary));
				table_data_tmp.rows[1].push(this.format_money(this.inputs.val_sub_alimentation));
				table_data_tmp.rows[3].push(this.format_money(val_sujeito_a_irs_seg_social));
				table_data_tmp.rows[4].push(this.format_money(sub_food_sujeito_a_irs_seg_e_social));
				table_data_tmp.rows[5].push(this.format_money(sal_brute));
				table_data_tmp.rows[6].push('<span class="text-primary">' +this.tax_irs+ ' %</span>');
				table_data_tmp.rows[7].push('<span class="text-primary">' +this.inputs.seg_social+ ' %</span>');
				table_data_tmp.rows[8].push('<span class="text-primary">' +this.inputs.adse+ ' %</span>');
				table_data_tmp.rows[9].push('<span class="text-danger">-' +this.format_money(retencao_irs_total)+ '</span>');
				table_data_tmp.rows[10].push('<span class="text-danger">-' +this.format_money(seg_social_total)+ '</span>');
				table_data_tmp.rows[11].push('<span class="text-danger">-' +this.format_money(ADSE_total)+ '</span>');
				table_data_tmp.rows[12].push('<span class="text-danger">-' +this.format_money(imposto_total)+ '</span>');
				table_data_tmp.rows[2].push('<span class="text-success" style="font-size:16px;">' +this.format_money(sub_food_total)+ '</span>');
				['Renumeração Liquída', '<span b class="text-success" style="font-size:16px;">' +this.format_money(net_salary-sub_food_total)+ '</span>'],
				table_data_tmp.rows[13].push('<b class="text-success" style="font-size:16px;">' +this.format_money(net_salary)+ '</b>');

			}

			this.table_data = table_data_tmp;
		}
	},
	created() {
		const that = this;
		that.get_req('net-salary/get_years',
			function() { // before
				//that.loading = true;
            },
			function(response) { // success
				that.years = response.body.years;
				that.year = that.years[0];
				that.years_regions = response.body.regions;
				that.isencoes = response.body.isencoes;
			},
			function(response) { // fail
				console.log('ajax main.js error: '+ response.status);
			},
			function(response) {
				
			});
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.local-badge {
		max-width: 100px;
	}
</style>
<style>
	
</style>